module.exports = __webpack_public_path__ + "static/img/noNotice.aa94340b.svg";